module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/bg-1m-e8ab2ee46071bdf625f6adf26fd72061.png";